import Modal from "components/layout/modal";
import { FunctionComponent } from "react";
import SubmitModalForm from "./submit-modal-form";

interface SubmitModalProps {
  onSubmit: () => Promise<void>;
  onClose: () => Promise<void>;
}

const SubmitModal: FunctionComponent<SubmitModalProps> = ({
  onSubmit,
  onClose,
}) => {
  const handleSubmit = async () => {
    await onSubmit();
    await onClose();
  };

  return (
    <Modal title="Lähetä tarkastettavaksi">
      <SubmitModalForm onSubmit={handleSubmit} onClose={onClose} />
    </Modal>
  );
};

export default SubmitModal;
